import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import FormDatePicker from '@views/components/Inputs/FormDatePicker';
import { Col, Form, Row } from 'antd';

import { routeFileSelector } from '@/utilz';
import FormTextArea from '@/views/components/Inputs/FormTextArea';
import FormLabel from '@/views/components/Labels/FormLabel';

const SaversShipmentSearch = ({ form }) => {
  const orderShipDateFrom = Form.useWatch('orderShipDateFrom', form);
  const orderShipDateTo = Form.useWatch('orderShipDateTo', form);
  const orderCreatedDateFrom = Form.useWatch('orderCreatedDateFrom', form);
  const orderCreatedDateTo = Form.useWatch('orderCreatedDateTo', form);
  const poNumber = Form.useWatch('poNumber', form);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <Row>
      <Col sm={24}>
        <FormTextArea
          editMode
          label={t('translation:default.fields.shipmentNumber.placeholder')}
          placeholder={t('translation:default.fields.shipmentNumber.placeholder')}
          name="ShipmentNo"
          rows={3}
        />
      </Col>
      <Col sm={24}>
        <FormTextArea
          editMode
          label={t('translation:default.fields.trailerNumber')}
          placeholder={t('translation:default.fields.trailerNumber')}
          name="trailerNumber"
          rows={3}
        />
      </Col>

      <Col sm={24} className="mb-15">
        <FormLabel>{t('translation:purchase-order-view.fields.date.createdDate')}</FormLabel>
        <Row className="mt-3 align-items-center" gutter={5}>
          <Col sm={4} className="text-right">
            <FormLabel>{`${t('translation:default.fields.from.label')} :`}</FormLabel>
          </Col>
          <Col sm={20}>
            <FormDatePicker
              name="orderCreatedDateFrom"
              placeholder={t('translation:purchase-order-view.fields.date.placeholder')}
              margin="mb-0"
              disableFuture
              disabledTargetDate={orderCreatedDateTo}
              rules={
                orderCreatedDateTo
                  ? [
                      orderCreatedDateTo && {
                        message: t('translation:purchase-order-view.fields.date.messageFromCreateOnDate'),
                        required: true,
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
        <Row className="mt-6 align-items-center" gutter={5}>
          <Col sm={4} className="text-right">
            <FormLabel>{`${t('translation:default.fields.to.label')} :`}</FormLabel>
          </Col>
          <Col sm={20}>
            <FormDatePicker
              name="orderCreatedDateTo"
              placeholder={`${t('translation:default.fields.to.label')} :`}
              margin="mb-0"
              disableFuture={false}
              disabledTargetDate={orderCreatedDateFrom}
              rules={
                orderCreatedDateFrom
                  ? [
                      {
                        message: t('translation:purchase-order-view.fields.date.messageToCreateOnDate'),
                        required: true,
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col sm={24}>
        <FormLabel>{t('translation:default.fields.shipDate.label')}</FormLabel>
        <Row className="mt-3 align-items-center" gutter={5}>
          <Col sm={4} className="text-right">
            <FormLabel>{`${t('translation:default.fields.from.label')} :`}</FormLabel>
          </Col>
          <Col sm={20}>
            <FormDatePicker
              name="orderShipDateFrom"
              placeholder={t('translation:purchase-order-view.fields.date.placeholder')}
              margin="mb-0"
              disableFuture
              disabledTargetDate={orderShipDateTo}
              rules={
                poNumber
                  ? []
                  : [
                      ...(orderShipDateTo
                        ? [
                            {
                              message: t('translation:purchase-order-view.fields.date.messageFromShipnDate'),
                              required: true,
                            },
                          ]
                        : []),
                    ]
              }
            />
          </Col>
        </Row>
        <Row className="mt-6 align-items-center" gutter={5}>
          <Col sm={4} className="text-right">
            <FormLabel>{`${t('translation:default.fields.to.label')} :`}</FormLabel>
          </Col>
          <Col sm={20}>
            <FormDatePicker
              name="orderShipDateTo"
              placeholder={t('translation:purchase-order-view.fields.date.placeholder')}
              margin="mb-0"
              disableFuture={false}
              disabledTargetDate={orderShipDateFrom}
              rules={
                poNumber
                  ? []
                  : [
                      ...(orderShipDateFrom
                        ? [
                            {
                              message: t('translation:purchase-order-view.fields.date.messageToShipDate'),
                              required: true,
                            },
                          ]
                        : []),
                    ]
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SaversShipmentSearch;
